import { Component } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  template: `
    <div
      class="rounded-md px-3 py-3 text-xs break-words z-50 bg-primary-5 text-neutral-700 font-bold relative max-w-[500px] shadow-lg shadow-black/30">
      @if (title) {
        <span class="font-bold text-primary-700 mb-4 block">{{ title }}</span>
      }
      <span class="preserve-line-breaks">{{ text }}</span>
      <div [class]="getArrowClass()"></div>
    </div>
  `,
})
export class TooltipComponent {
  text = '';
  title: string | null = '';
  position: 'top' | 'bottom' | 'left' | 'right' = 'top';

  private readonly arrowClasses: Record<string, string> = {
    top: 'absolute bottom-[-6px] left-1/2 -translate-x-1/2 w-0 h-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-primary-5 border-b-0',
    bottom:
      'absolute top-[-6px] left-1/2 -translate-x-1/2 w-0 h-0 border-x-[6px] border-x-transparent border-b-[6px] border-b-primary-5 border-t-0',
    left: 'absolute top-1/2 -translate-y-1/2 right-[-10px] w-0 h-0 border-y-[10px] border-y-transparent border-l-[10px] border-l-primary-5 border-r-0',
    right:
      'absolute top-1/2 -translate-y-1/2 left-[-10px] w-0 h-0 border-y-[10px] border-y-transparent border-r-[10px] border-r-primary-5 border-l-0',
  };

  getArrowClass(): string {
    return this.arrowClasses[this.position] || this.arrowClasses['top'];
  }
}
